/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/** Numéro de parent dans l'assistant : 1 = père (`PER`), 2 = mère (`MER`). */
export type NumeroParent = 1 | 2;

/**
 * Parents auteurs de la reconnaissance, par code `ec_autrec.au_codj`.
 *
 * Un parent auteur reconnaît l'enfant : il est nécessairement identifié, et ne
 * peut donc pas être déclaré inconnu. L'autre parent, lui, l'est souvent.
 *
 */
const PARENTS_AUTEURS: Record<string, NumeroParent[]> = {
  P: [1],
  M: [2],
  PM: [1, 2],
};

/**
 * Numéros des parents auteurs de la reconnaissance, donc **obligatoires**.
 *
 * Rend un tableau vide quand le code est absent ou inconnu — notamment sur un
 * acte de naissance, qui n'a pas d'auteur de reconnaissance : les appelants
 * partagés voient alors « aucune contrainte », soit le comportement historique.
 */
export const numerosParentsAuteurs = (
  codeAuteurReconnaissance?: string | null,
): NumeroParent[] => PARENTS_AUTEURS[codeAuteurReconnaissance ?? ''] ?? [];

/** Un parent peut-il être déclaré inconnu ? Faux s'il est auteur de l'acte. */
export const filiationInconnueAutorisee = (
  numeroParent: NumeroParent,
  codeAuteurReconnaissance?: string | null,
): boolean =>
  !numerosParentsAuteurs(codeAuteurReconnaissance).includes(numeroParent);

export default PARENTS_AUTEURS;
